import { useNavigate } from 'react-router-dom';
import usePushStore from '../store/toast';
import Cookies from 'universal-cookie';
import { usePushNotifications } from './pushNotification';

export const useAuth = () => {
    const navigate = useNavigate();
    const cookies = new Cookies();

    const onLogOutHandler = () => {
        cookies.remove('auth', { path: '/' });
        cookies.remove('refresh', { path: '/' });
        localStorage.removeItem('not_one_account');
        localStorage.removeItem('client_id');
        localStorage.removeItem('email');
        if (localStorage.getItem('auth')) localStorage.removeItem('auth');
        if (localStorage.getItem('refresh')) localStorage.removeItem('refresh');
        localStorage.removeItem('general-storage');
        navigate('/auth');
    };

    return {
        onLogOutHandler
    };
};


// Обработка ошибок в fetch запросах

export const useResponseHandler = () => {
    const { onLogOutHandler } = useAuth();
    const addPush = usePushStore((state) => state.addPush);
      // Обработка ошибок
      const { addErrorPush, addSuccessPush, addWarningPush } = usePushNotifications()

    // type 'error' | 'success'
    const addPushTooltip = (text = 'Это информационное сообщение', type = 'error') => {
        addPush({
            type: type,
            title: 'Ошибка',
            message: text,
            timeout: 5000,
        });
    }

    const handleStatusCode = (statusCode) => {
        switch (statusCode) {
            case 401: // часто 401 тоже обрабатывают как необходимость logout
                onLogOutHandler();
                return true;
            case 500:
                addPushTooltip(`Ошибка на стороне сервера, обратитесь к разработчикам за подробной информацией. 500 - Internal Server Error`);
                return false;
            case 404:
                addPushTooltip(`Не корректный запрос, обратитесь к разработчикам за подробной информацией. 404 - Resource not found`);
                return false;
            default:
                return false;
        }
    };

    const isAbortError = (error) => {
        return error?.name === 'AbortError' ||
            error?.code === 'ERR_CANCELED' ||
            error?.message?.includes('aborted');
    };

    const handleTableResponse = (res) => {
        if (res.ok) {
            return res.json();
        } else {
            if (handleStatusCode(res.status)) {
                return;
            }
            throw new Error(`Failed to load: ${res.status} ${res.statusText}`);
        }
    }

    const handleRequestError = (error) => {
        if (isAbortError(error)) {
            console.log('signal is aborted without reason');
            return Promise.resolve();
        }

        console.error(error);
        return Promise.resolve();
    };

    return {
        handleTableResponse,
        handleStatusCode,
        handleRequestError
    };
};